<style scoped>

</style>

<template>
  <!--    class="section-settings-container__form"-->
  <div
    class=""
    style="display: flex; flex-direction: column; justify-content: space-between;"
  >
    <div v-if="!$store.state.activeTemplate.isWizardEnabled"  class="section-title-container">
<!--      <div class="section-title">{{ translate(section.title) }}</div>-->
<!--      <TemplateSectionDescription :section="section"/>-->
    </div>
    <div>
      <v-text-field
        :label="translate('ui_npv_wacc')"
        v-model="$store.state.activeTemplate.data.options.modules.npv.wacc"
        required
        outlined
        dense
        background-color="white"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-text-field>

      <v-text-field
        :label="translate('ui_npv_tg')"
        v-model="$store.state.activeTemplate.data.options.modules.npv.tgr"
        required
        outlined
        dense
        background-color="white"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-text-field>

      <v-text-field
        :label="translate('ui_npv_ebitda_mult')"
        v-model="$store.state.activeTemplate.data.options.modules.npv.ebitda_multiple"
        required
        outlined
        dense
        background-color="white"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-text-field>
    </div>
    <DialogSection :section="section" :selectNextSection="selectNextSection"/>
  </div>
</template>

<script>

// import TemplateSectionDescription
//   from '@/components/sections/TemplateSection/TemplateSectionDescription';
// import DialogToolbarBottom from '@/components/dialogs/DialogToolbarBottom.vue';
import DialogSection from '@/components/dialogs/DialogSection';
import Mixin from '../../mixins/mixin';


export default {
  name: 'NPVEditDialog',
  components: {
    DialogSection,
    // DialogToolbarBottom,
    // TemplateSectionDescription,
  },
  mixins: [Mixin],
  props: ['section', 'selectNextSection'],
  data: () => ({
    dialogAssumptions: [],
  }),
  methods: {},
};
</script>
